import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = {
  key: 1,
  class: "error-message"
}

import { useBookings } from '@/composables/useBookings'
  import { useI18n } from 'vue-i18n'
  import { computed, onMounted } from 'vue'

  // VUE Components
  import ViewWrapper from '@/components/UI/ViewWrapper.vue'
  import BookingList from '@/components/common/BookingList.vue'
  import QuoteSkeleton from '@/components/Quotes/QuoteSkeleton.vue'
  import store from '@/store'

  // Translations
  
export default /*@__PURE__*/_defineComponent({
  __name: 'QuotesView',
  setup(__props) {

  const { t } = useI18n()

  // Bookings Map
  const bookingsMap = {
    quotes: computed(() => store.getters['booking/quotesAndCartInProgress']),
  }

  const {
    isLoading,
    error,
    updatedBookings,
    fetchAndMapBookings,
    openPanelByRef,
  } = useBookings(bookingsMap)

  onMounted(async () => {
    await fetchAndMapBookings()
    openPanelByRef()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ViewWrapper, {
    id: "quotes",
    title: _unref(t)('quotes.pageTitle'),
    class: "w-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isLoading))
          ? (_openBlock(), _createBlock(QuoteSkeleton, {
              key: 0,
              class: "mb-2"
            }))
          : (_unref(error))
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('errorMessages.fetchBookings')), 1))
            : (_openBlock(), _createBlock(BookingList, {
                key: 2,
                bookings: _unref(updatedBookings).quotes.value,
                "empty-title-key": "quotes.noQuote",
                "empty-description-key": "quotes.timeToChoose"
              }, null, 8, ["bookings"]))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})